import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Success = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={FeedbackSignals.Success}>
    {children}
  </InlineFeedbackBase>
);

export default Success;
